import React, { useMemo } from 'react';

import type IGameSettings from 'types/models/IGameSettings';
import ReactVirtualGrid from '../../../shared/components/VirtualizedGrid/ReactVirtualGrid';
import ReactVirtualVerticalGrid from '../../../shared/components/VirtualizedGrid/ReactVirtualVerticalGrid';
import TopSectionGrid from '../TopSectionGrid';
import { getGridType } from '../utils/getGridType';

import styles from './SectionGridRenderer.module.css';

interface SectionGridRendererProps {
  isInSingleView: boolean;
  games: IGameSettings[];
  isFav: boolean;
  sectionName: string;
  hasJackpotPanel: boolean;
  lobbyContainerRef: React.RefObject<HTMLDivElement | null> | undefined;
  scrollArrows: {
    isHovered: boolean;
    showLeftArrow: boolean;
    showRightArrow: boolean;
  };
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
  scrollLeft: () => void;
  scrollRight: () => void;
  ref: React.Ref<HTMLDivElement>;
}

const SectionGridRenderer = ({
  isInSingleView,
  games,
  isFav,
  sectionName,
  hasJackpotPanel,
  lobbyContainerRef,
  scrollArrows,
  handleMouseEnter,
  handleMouseLeave,
  scrollLeft,
  scrollRight,
  ref: gridContainerRef,
}: SectionGridRendererProps) => {
  const gridType = useMemo(() => getGridType(sectionName, isInSingleView), [sectionName, isInSingleView]);

  const getSectiongridRenderer = () => {
    switch (gridType) {
      case 'horizontal':
        return (
          <ReactVirtualGrid
            games={games}
            isFav={isFav}
            sectionName={sectionName}
            hasJackpotPanel={hasJackpotPanel}
            ref={gridContainerRef}
          />
        );
      case 'vertical':
        return (
          <ReactVirtualVerticalGrid
            games={games}
            isFav={isFav}
            sectionName={sectionName}
            hasJackpotPanel={hasJackpotPanel}
            scrollContainerRef={lobbyContainerRef}
            ref={gridContainerRef}
          />
        );
      case 'top':
      default:
        return (
          <div
            className={styles['scrollableGridWrapper']}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <TopSectionGrid
              games={games}
              sectionName={sectionName}
              hasJackpotPanel={hasJackpotPanel}
              gridContainerRef={gridContainerRef as React.RefObject<HTMLDivElement>}
              scrollArrows={scrollArrows}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
            />
          </div>
        );
    }
  };

    return getSectiongridRenderer();
};

SectionGridRenderer.displayName = 'SectionGridRenderer';

export default SectionGridRenderer;
